<template>
  <v-container>
    <v-row > 
      <div id="svg" class="box"/>  
      <canvas id="myCanvas" :width="canvasX" :height="canvasY" class="canvas_style" />
      <!-- <v-col cols="4">
        <v-text-field
          v-model="foreignId"
          label="Foreign ID"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-file-input v-if="foreignId" v-model="selectedFile" show-size label="New DXF"></v-file-input>
      </v-col>
      <v-col v-if="foreignId" cols="4">
        <v-btn block color="green" @click="loadSvg(foreignId)">Load</v-btn>
      </v-col> -->
      <!-- <v-col cols="12"  class="font-weight-bold">  
        {{lines}}
      </v-col> -->
       <v-col cols="6">  
        <v-btn class="ma-2" @click="movePoint(10, -1, 'X'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-double-left</v-icon></v-btn>
        <v-btn class="ma-2" @click="movePoint(0.25, -1, 'X'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn class="ma-2" @click="movePoint(0.25, 1, 'X'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-right</v-icon></v-btn>
        <v-btn class="ma-2" @click="movePoint(10, 1, 'X'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-double-right</v-icon></v-btn>      
        <v-btn class="ma-2" @click="movePoint(10, -1, 'Y'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-double-up</v-icon></v-btn>
        <v-btn class="ma-2" @click="movePoint(0.25, -1, 'Y'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-up</v-icon></v-btn>     
        <v-btn class="ma-2" @click="movePoint(0.25, 1, 'Y'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-down</v-icon></v-btn>
        <v-btn class="ma-2" @click="movePoint(10, 1, 'Y'); clearCanvas(); drawInitPoints(); "><v-icon>mdi-chevron-double-down</v-icon></v-btn>
        <v-btn class="ma-2" @click="rotateCounterClock(); clearCanvas(); drawInitPoints(); "><v-icon>mdi-rotate-left</v-icon></v-btn>
        <v-btn class="ma-2" @click="rotateClock(); clearCanvas(); drawInitPoints(); "><v-icon>mdi-rotate-right</v-icon></v-btn>
        <v-btn class="ma-2" @click="reDrawCanvas(); ">Draw Lines</v-btn>
        <v-btn class="ma-2" @click="clearCanvas(); drawPoles(); ">Draw Poles</v-btn>
        
      </v-col>
      <v-col cols="1" class="mt-4">
        <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.rotationAngleDegrees"
          label="Rotation Angle Start"
          >
        </v-text-field> 
        <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.rotationAngleDegreesSteps"
          label="Rotation Angle Steps"
          >
        </v-text-field> 
      </v-col>
      <v-col cols="1" class="mt-4">
        <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.Ax"
          label="Init A.x"
          >
        </v-text-field> 
        <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.Ay"
          label="Init A.y"
          >
        </v-text-field> 
      </v-col>
      <v-col cols="1" class="mt-4">
        <v-text-field
          flat  
          dense
          disabled
          type="Number"
          v-model="points_settings.Bx"
          label="Init B.x"
          >
        </v-text-field> 
        <v-text-field
          flat  
          dense
          disabled
          type="Number"
          v-model="points_settings.By"
          label="Init B.y"
          >
        </v-text-field> 
      </v-col>
      <v-col cols="1" class="mt-4">
        <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.reference_angle"
          label="Reference Angle"
          >
        </v-text-field> 
        <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.length"
          label="AB Length"
          >
        </v-text-field> 
      </v-col>
      <v-col cols="1" class="mt-4">
        <!-- <v-text-field
          flat  
          dense
          type="Number"
          v-model="points_settings.ABangle"
          label="AB angle"
          >
        </v-text-field>  -->
        <v-btn class="ma-0" color="red" @click="clearCanvas(); ">Clear</v-btn>
      </v-col>
      <v-col cols="1" class="mt-4">
        <v-btn class="ma-1" color="green" @click="loadSettings(); ">Load</v-btn>
        <v-btn class="ma-1" color="orange" @click="saveSettings(); ">Save</v-btn>
      </v-col>
    </v-row>
    <div>
      <!-- <v-img src="../assets/mapimage.png"/> -->
      <img
        class="image_style"
        src="../assets/mapimage.png"/>
    </div>
     <!-- class="image_style" -->
    <!-- <v-row class="dataPosition"> 
      <v-data-table
        :headers="headers_triangle"
        :items="calculated_triangles"
      >
      </v-data-table>
    </v-row> -->


      <v-row class="dataPosition">
        <v-col  cols="3">
          <v-data-table
            :headers="headers_triangle"
            :items="calculated_triangles"
            dense
            :footer-props="{'items-per-page-options': [25, 50, 100, -1] }"
            :items-per-page="100"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Triangles</v-toolbar-title>    
              </v-toolbar>
            </template>
          </v-data-table>
        </v-col>
   
        <v-col cols="3">
          <v-data-table
            :headers="headers_points"
            :items="points"
            dense
            :footer-props="{'items-per-page-options': [25, 50, 100, -1] }"
            :items-per-page="100"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Points</v-toolbar-title>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="3">
          <v-data-table
            :headers="headers_inputs"
            :items="inputs"
            dense
            :footer-props="{'items-per-page-options': [25, 50, 100, -1] }"
            :items-per-page="100"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lines</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="green" left fab small dark class="mb-2" @click="createItem">
                  <v-icon>
                    add
                  </v-icon>
                </v-btn>
                <v-dialog v-model="dialog" max-width="500px">
                  
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-text-field
                            v-model="editedItem.start"
                            label="Start"
                            autofocus
                            >
                          </v-text-field> 
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="editedItem.end"
                            label="End"
                            >
                          </v-text-field> 
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="editedItem.angle"
                            label="Angle"
                            >
                            </v-text-field> 
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="close">Close</v-btn>
                      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>

        <v-col  cols="3">
          <v-data-table
            :headers="headers_pol"
            :items="Pols"
            dense
            :footer-props="{'items-per-page-options': [25, 50, 100, -1] }"
            :items-per-page="100"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Pol</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="green" left fab small dark class="mb-2" @click="createItemPole">
                  <v-icon>
                    add
                  </v-icon>
                </v-btn>
                <v-dialog v-model="dialog_pole" max-width="500px">
                  
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-text-field
                            v-model="editedItemPole.name"
                            label="Name"
                            autofocus
                            >
                          </v-text-field> 
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="editedItemPole.reference"
                            label="reference"
                            >
                          </v-text-field> 
                        </v-row>   
                        <v-row>
                          <v-text-field
                            v-model="editedItemPole.reference_angle"
                            label="reference_angle"
                            >
                          </v-text-field> 
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="editedItemPole.pole"
                            label="Pole"
                            >
                          </v-text-field> 
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="editedItemPole.angle"
                            label="Angle"
                            >
                          </v-text-field> 
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="editedItemPole.length"
                            label="length"
                            >
                          </v-text-field> 
                        </v-row>
                         <v-row>
                          <v-text-field
                            v-model="editedItemPole.activated"
                            label="activated"
                            >
                          </v-text-field> 
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="closePole">Close</v-btn>
                      <v-btn color="blue darken-1" text @click="savePole">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItemPole(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItemPole(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>


    <v-snackbar v-model="snackbar" :color="snackbar_color">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbar = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "Home",
  components: {
  },

  data() {
    return {
      dialog: false,
      dialog_pole: false,
      isLoaded: false,
      snackbar_text: "",
      snackbar: false,
      snackbar_color: "red",
      mouseX: 0,
      mouseY: 0,
      scaleFactor: 0,
      canvasX: 0,
      canvasY: 1900,
      canvas: null,
      isDrawing: false,
      lines: [],
      selectedFile: null,
      viewBox: {},
      foreignId: null,
      oldPoint: null,
      pointsCounter: 0,

      image_y2: 5212332.25,
      image_y1: 5211917.39,
      image_x1: 490522.18,
      image_x2: 491152.42,
      image_width: 2791,
      image_height: 1837,
      
      inputs: [
        // {start: "A", end: "B", angle: 153.591, length: 132.14, calculated: true},
        // {start: "B", end: "A", angle: 39.591, length: 0, calculated: true},
        // {start: "A", end: "C", angle: 132.931, length: 0, calculated: false},
        // {start: "A", end: "D", angle: 89.690, length: 0, calculated: false},
        // {start: "A", end: "1", angle: 110.377, length: 0, calculated: false},
        // {start: "B", end: "C", angle: 176.992, length: 0, calculated: false},
        // {start: "B", end: "D", angle: 117.260, length: 0, calculated: false},
        // {start: "B", end: "1", angle: 155.229, length: 0, calculated: false},
        
        // {start: "D", end: "7", angle: 94.866, length: 0, calculated: false},
        // {start: "D", end: "C", angle: 341.149, length: 0, calculated: false},
        // {start: "D", end: "5", angle: 113.175, length: 0, calculated: false},
        // {start: "C", end: "7", angle: 278.181, length: 0, calculated: false},
        // {start: "C", end: "D", angle: 308.297, length: 0, calculated: false},
        // {start: "C", end: "5", angle: 276.582, length: 0, calculated: false},
        // {start: "C", end: "A", angle: 250.073, length: 0, calculated: false},
        // {start: "C", end: "B", angle: 228.115, length: 0, calculated: false},
       
      ],
      // points_init: [
      //   { name: "A",
      //     x: 1285.45, //1284.575416
      //     y: 317.5, // 319.7734941, 
      //     // x: 0,
      //     // y: 0,
      //     calculated: true
      //   },
      //   { name: "B",
      //     x: 773.243, //770.6677, //698.5, // 699.1095937, //
      //     y: 288.415, //325, // 268.6, // 266.203246, //
      //     // x: 132.14,
      //     // y: 0,
      //     calculated: true
      //   }
      // ],
      points_settings: {
        location: "",
        Ax: 1285.45,
        Ay: 317.5,
        reference_angle: 90,
        ABangle: 0,
        length: 300,
        rotationAngleDegrees: 186,
        rotationAngleDegreesSteps: 0.25
      },
      points: [],
      triangles: [
        //{a: "A", b: "B", c: "C", calculated: false, calculable: true}
      ],
      headers_triangle: [
        { text: 'A', value: 'a.name' },
        { text: 'B', value: 'b.name' },
        { text: 'C', value: 'c.name'} ,
        { text: 'Angle Sum', value: 'anglesum'},
       
      ],
      headers_points: [
        { text: 'Name', value: 'name' },
        { text: 'x', value: 'x' },
        { text: 'y', value: 'y'} ,
        { text: 'calculated', value: 'calculated'} ,
      ],
      headers_inputs: [
        { text: 'Start', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'angle', value: 'angle' },
        { text: 'Length', value: 'length' },
        { text: 'calculated', value: 'calculated'} ,
        { text: "Actions", value: "actions", sortable: false },
      ],

      headers_pol: [
        { text: 'name', value: 'name' },
        { text: 'pole', value: 'pole' },
        { text: 'reference', value: 'reference' },
        { text: 'angle', value: 'angle'} ,
        { text: 'reference_angle', value: 'reference_angle'},
        { text: 'length', value: 'length'} ,
        { text: "Actions", value: "actions", sortable: false },
      ],

      // rotationAngleDegrees: 186,
      // rotationAngleDegreesSteps: 0.25,

      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
        start: "",
        end: "",
        angle: 0,
        gon: true,
        length: 0,
        location: "",
        
      },

      editedIndexPole: -1,
      editedItemPole: {
      },
      defaultItemPole: {
        pole: "",
        reference: "",
        angle: 0,
        reference_angle: 0,
        gon: true,
        length: 0,
        location: "",
        activated: true
      },
    };
  },

  created () {
    this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
    this.editedItemPole = JSON.parse(JSON.stringify(this.defaultItemPole));
    //this.points = JSON.parse(JSON.stringify(this.points_init));
    // this.setInitPoints();
    const image_x = this.image_x2 - this.image_x1;
    const image_y = this.image_y2 - this.image_y1;
    const scale1 = this.image_width / image_x;
    const scale2 = this.image_height / image_y;
    //console.log("Scale: ", scale1, scale2, this.image_width / 630);
    this.scaleFactor = scale1;
    // this.inputs[0].length = this.inputs[0].length * this.scaleFactor;
    // this.inputs[1].length = this.inputs[0].length ;
    //this.points[0].x = this.points[0].x + this.inputs[0].length;
  },

  async mounted() {
    
    const c = document.getElementById("myCanvas");
    this.canvas = c.getContext('2d');
    this.canvasX = 4000;

    // console.log("Mounting");
    document.addEventListener("mousemove", (event) => {
      this.mouseX = event.offsetX;
      this.mouseY = event.offsetY;
    });
    
    await this.getSettings();
    // console.log("Settings: ", this.Settings);
    if (this.Settings) {
      this.points_settings = this.Settings;
    }
    this.setInitPoints();
    this.calcSettings();

    // this.points_init()
    

    await this.getLines();
    await this.getPols();
    
    
    let lineArray = [];
    for (let line of this.Lines) {
      line.calculated = false;
      lineArray.push(line);
    }
    this.inputs = _.sortBy(lineArray,[function(obj) { return obj._id; }]);

    //console.log(this.inputs)

    this.startCalc();


    ///this.drawPoints();
  },

  computed: {
    ...mapState({
        // Svg: ({ svg }) => svg,
        Lines: ({ line }) => line.Lines,
        Pols: ({ pol }) => pol.Pols,
        LineState: ({ line }) => line,
        PolState: ({ pol }) => pol,
        Settings: ({ setting }) => setting.Settings,
        SettingState: ({ setting }) => setting,
    }),

    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

   calculated_triangles() {
    return this.triangles.filter(obj => {
      return obj.calculated == true; 
    })
   }
  },

  methods: {

    ...mapActions("svg", [
      "getSvg",
      "convertDxf",
    ]),
    ...mapActions("line", [
      "getLines",
      "createLine",
      "updateLine",
      "deleteLine"
    ]),
    ...mapActions("pol", [
      "getPols",
      "createPol",
      "updatePol",
      "deletePol"
    ]),
    ...mapActions("setting", [
      "getSettings",
      "createSetting",
      "updateSetting",
      "deleteSetting"
    ]),

    setInitPoints() {
      this.points = 
      [
        { name: "A",
          x: this.points_settings.Ax,
          y: this.points_settings.Ay,
          calculated: true
        },
        { name: "B",
          x: this.points_settings.Bx,
          y: this.points_settings.By,
          calculated: true
        }
      ];
    },

    async loadSettings() {
      await this.getSettings();
      this.points_settings = this.Settings;
      this.calcSettings();
    },
    async saveSettings() {
      console.log("Save Settings: ", this.points_settings, this.Settings);
      if (!this.Settings) {
        await this.createSetting(this.points_settings);
      } 
      else {
        await this.updateSetting(this.points_settings);
      }
      
    },

    clearCalc() {
      for (let i = 2; i < this.inputs.length; i++) {
        this.inputs[i].calculated = false;
      }
      this.triangles = [];
      for (let i = 2; i < this.points.length; i++) {
        this.points[i].calculated = false;
      }
    },

    clearCanvas() {
      console.log("clearCanvas")
      this.canvas.clearRect(0, 0, this.canvasX, this.canvasY);
    },

    reDrawCanvas() {
      // this.points = JSON.parse(JSON.stringify(this.points_init));
      this.setInitPoints();
      //console.log("Clear Canvas")
      this.clearCanvas();
      //console.log("Clear Calc")
      
      this.clearCalc();
      //console.log("startCalc")
      this.startCalc();
      //console.log("drawPoints")
      this.drawPoints();
    },

    movePoint(move, direction, axis) {
      if (axis == "X") {
        this.points_settings.Ax = this.points[0].x =  Number((this.points[0].x + (move * direction)).toFixed(3));
        this.points_settings.Bx = this.points[1].x =  Number((this.points[1].x + (move * direction)).toFixed(3)); 
      } else {
        this.points_settings.Ay = this.points[0].y =  Number((this.points[0].y + (move * direction)).toFixed(3)); 
        this.points_settings.By = this.points[1].y =  Number((this.points[1].y + (move * direction)).toFixed(3));
      }
    },

    rotateClock() {
      this.points_settings.rotationAngleDegrees += this.points_settings.rotationAngleDegreesSteps;
      const rotationAngleRadians = this.points_settings.rotationAngleDegrees * (Math.PI / 180);
      // this.points[1].x = this.points[0].x + this.inputs[0].length * Math.cos(rotationAngleRadians);
      // this.points[1].y = this.points[0].y + this.inputs[0].length * Math.sin(rotationAngleRadians);
      this.points[1].x = this.points[0].x + this.points_settings.length * this.scaleFactor * Math.cos(rotationAngleRadians);
      this.points[1].y = this.points[0].y + this.points_settings.length * this.scaleFactor * Math.sin(rotationAngleRadians);
      this.points_settings.Bx = Number((this.points[1].x).toFixed(3));
      this.points_settings.By = Number((this.points[1].y).toFixed(3));
      this.points_settings.reference_angle = rotationAngleRadians;
    },

    rotateCounterClock() {
      this.points_settings.rotationAngleDegrees += -this.points_settings.rotationAngleDegreesSteps;
      const rotationAngleRadians = this.points_settings.rotationAngleDegrees * (Math.PI / 180);
      this.points[1].x = this.points[0].x + this.points_settings.length * this.scaleFactor * Math.cos(rotationAngleRadians);
      this.points[1].y = this.points[0].y + this.points_settings.length * this.scaleFactor * Math.sin(rotationAngleRadians);
      this.points_settings.Bx =  Number((this.points[1].x).toFixed(3));
      this.points_settings.By =  Number((this.points[1].y).toFixed(3));
      this.points_settings.reference_angle = rotationAngleRadians;
    },

    pickPoint() {
      for (let point of this.points) {
        if (!point.calculated) {
          point.calculated = true;
          return point;
        }
      }
    },

    startCalc() {
      
       //const point = pickPoint();
      
      for (let line of this.inputs) {
        //find all points
        let point = this.points.find(p => {
          return p.name == line.start;
        })
      
        if (!point) {
          this.points.push( 
            { name: line.start,
              x: 0,
              y: 0,
              calculated: false
            }
          )
        }
        point = null;
        point = this.points.find(p => {
          return p.name == line.end;
        })
        if (!point) {
          this.points.push( 
            { name: line.end,
              x: 0,
              y: 0,
              calculated: false
            }
          )
        }
      }
      //console.table(this.points);
      // for (let point of this.points) {
      //console.log("Start Check Triangles from points: ", this.points.length);
      for (let pointA of this.points) {
        for (let pointB of this.points) {
          for (let pointC of this.points) {
            const triangle = this.triangles.find(t => {
              return t.a.name == pointA.name && t.b.name == pointB.name && t.c.name == pointC.name;
            });
            if (!triangle && pointA.name != pointB.name && pointA.name != pointC.name && pointB.name != pointC.name) {
              this.triangles.push({a: pointA, b: pointB, c: pointC, calculated: false, calculable: false})
              //console.log(pointA.name, pointB.name, pointC.name)
            }
          }              
        }
      }
      // }

      //console.log("Start Find Lines: ");
      for (let triangle of this.triangles) {
        //console.log("Start Check calculable Triangles: ", this.triangles.length, triangle.a.name, triangle.b.name, triangle.c.name);
        const findAB = this.inputs.find(l => {
          return l.start == triangle.a.name && l.end == triangle.b.name;
        });
        //console.log("findAB: ", findAB);
        const findAC = this.inputs.find(l => {
          return l.start == triangle.a.name && l.end == triangle.c.name;
        });
        //console.log("findAC: ", findAC);
        const findBA = this.inputs.find(l => {
          return l.start == triangle.b.name && l.end == triangle.a.name;
        });
        //console.log("findBA: ", findBA);
        const findBC = this.inputs.find(l => {
          return l.start == triangle.b.name && l.end == triangle.c.name;
        });
        //console.log("findBC: ", findBC);
        if (findAB && findAC && findBA && findBC) {
          //console.log("found calculable: ", triangle.a.name, triangle.b.name, triangle.c.name);
          triangle.calculable = true;     
          triangle.ab = findAB; 
          triangle.ac = findAC; 
          triangle.ba = findBA; 
          triangle.bc = findBC; 
        }     
      }

      //console.log("Start calcTrinagles & Lines ");
      let count = 1;
      let depth = 4;
      while(count > 0 && depth > 0) {
        depth--;
        let filteredTriangles = this.triangles.filter(obj => {
          return !obj.c.calculated && obj.calculable
        });
        count = filteredTriangles.length;
        //console.log("filteredTriangles ", filteredTriangles, count);

        for (let triangle of filteredTriangles) {
          // if (triangle.calculable && !triangle.calculated) {
            this.calcTriangle(triangle);
            this.calcLines();
          // }
        }

      }
      

      //if (!line.calculated && line.start == point.name) {
        //Starte mit noch nicht kalkulierter Linie

      // }
      
    },

    calcTriangle (triangle) {
    
      //console.log(triangle.a.name, triangle.b.name, triangle.c.name, triangle);
      //console.log(triangle.a.calculated && triangle.b.calculated && triangle.ab.calculated && !triangle.c.calculated)
      if (triangle.a.calculated && triangle.b.calculated && triangle.ab.calculated && !triangle.c.calculated) {
        //console.log(triangle.a.name, triangle.b.name, triangle.c.name, triangle);
        
        let rotation_ac = 1;
        
        let angle_ac = 0;
        if (triangle.ac.angle >= triangle.ab.angle) {
          angle_ac = triangle.ac.angle - triangle.ab.angle;
          if (angle_ac > 180) {
            rotation_ac = -1;
            angle_ac = 360 - triangle.ac.angle + triangle.ab.angle;
          }
        } else {
          rotation_ac = -1;
          angle_ac = triangle.ab.angle - triangle.ac.angle;
          if (angle_ac > 180) {
            rotation_ac = 1;
            angle_ac = 360 - triangle.ab.angle + triangle.ac.angle;
          }
        }

        let angle_bc = 0; 
        if (triangle.bc.angle >= triangle.ba.angle) {
          angle_bc = triangle.bc.angle - triangle.ba.angle;
          if (angle_bc > 180) {
            angle_bc = 360 - triangle.bc.angle + triangle.ba.angle;
          }
        } else {
          angle_bc = triangle.ba.angle - triangle.bc.angle;
          if (angle_bc > 180) {
            angle_bc = 360 - triangle.ba.angle + triangle.bc.angle;
          }
        }

        const tanA = Math.tan((angle_ac * Math.PI) / 180);
        const tanB = Math.tan((angle_bc * Math.PI) / 180);

        const h = (triangle.ab.length * tanA * tanB) / (tanB + tanA);
        const AB1 = h / tanA;
        const AB2 = h / tanB;
      
        // Calculate the direction vector of AB
        const AB = { x: triangle.b.x - triangle.a.x, y: triangle.b.y - triangle.a.y };


        const AB_Length = Math.sqrt(AB.x ** 2 + AB.y ** 2);
        // Calculate the unit vector of AB
        const AB_UnitVector = { x: AB.x / AB_Length, y: AB.y / AB_Length };

        // Calculate the normal vector of AB
        let NormalVector = {};

        if (rotation_ac > 0) {
          //links drehend
          NormalVector = { x: -AB_UnitVector.y, y: AB_UnitVector.x };
        } else {
          //rechts drehend
          NormalVector = { x: AB_UnitVector.y, y: -AB_UnitVector.x };
        }


        const AB_Vector = { x: AB.x * AB1 / AB_Length, y: AB.y * AB1 / AB_Length };

        // Calculate the coordinates of point C
        const C = { 
          x: AB_Vector.x + triangle.a.x + NormalVector.x * h,
          y: AB_Vector.y + triangle.a.y + NormalVector.y * h 
        };

        //console.log(triangle.a.name, triangle.b.name, triangle.c.name, triangle, angle_ac, angle_bc, h, triangle.ab.length, AB1, AB2, AB, NormalVector, AB_Vector, C);
     
        this.points.push( { name: triangle.c.name,
          x: C.x,
          y: C.y,
          calculated: true
        });
        triangle.c.x = C.x;
        triangle.c.y = C.y;
        triangle.c.calculated = true;

        //Calc Lines AC & BC
        triangle.ac.length =  Math.abs(Math.sqrt(Math.pow((C.x - triangle.a.x), 2) + Math.pow((C.y - triangle.a.y), 2)));
        triangle.ac.calculated = true;
        triangle.bc.length = Math.abs(Math.sqrt(Math.pow((C.x - triangle.b.x), 2) + Math.pow((C.y - triangle.b.y), 2)));
        triangle.bc.calculated = true;

        // Calc angle CAB
        const findCA = this.inputs.find(l => {
          return l.start == triangle.c.name && l.end == triangle.a.name;
        });
        //console.log("findAB: ", findAB);
        const findCB = this.inputs.find(l => {
          return l.start == triangle.c.name && l.end == triangle.b.name;
        });
       
        if (findCA && findCB) {
          triangle.ca = findCA; 
          triangle.cb = findCB; 
          let angle_ca = 0;
          if (triangle.ca.angle >= triangle.cb.angle) {
            angle_ca = triangle.ca.angle - triangle.cb.angle;
            if (angle_ca > 180) {
              angle_ca = 360 - triangle.ca.angle + triangle.cb.angle;
            }
          } else {
            
            angle_ca = triangle.cb.angle - triangle.ca.angle;
            if (angle_ca > 180) {
              angle_ca = 360 - triangle.cb.angle + triangle.ca.angle;
            }
          }
          // Calc triangle angle sum
         
          triangle.anglesum = Number((angle_ac + angle_bc + angle_ca).toFixed(2));
        }

        //console.log(triangle.anglesum)
        triangle.calculated = true;

      } 
    
    },

    calcLines() {
      let filteredLines = this.inputs.filter(obj => {
        return !obj.calculated
      });
      
      if (filteredLines.length > 0) {
        for (let line of filteredLines ) {
          const pointStart = this.points.find(obj => {
            return obj.name == line.start && obj.calculated
          });
          const pointEnd = this.points.find(obj => {
            return obj.name == line.end && obj.calculated
          });
          //console.log("filteredLine ", line, pointStart, pointEnd)
          if (pointStart && pointEnd) {
            line.length =  Math.abs(Math.sqrt(Math.pow((pointEnd.x - pointStart.x), 2) + Math.pow((pointEnd.y - pointStart.y), 2)));
            line.calculated = true;  
          }
        }
      }
    },

    drawPoints() {
      
      // this.lines.push({id: 0, x: 200, y: 200, l: 0});
      // this.drawPoint(200, 200);
      // this.oldPoint = {x: 200, y: 200};
      // this.lines.push({id: 1, x: 400, y: 400, l: 100});
      // this.drawPoint(400, 400);
      // this.drawLine(this.oldPoint.x, this.oldPoint.y, 400, 400, 10);
      // this.oldPoint = {x: 200, y: 200};
      
      for (let triangle of this.triangles) {
        if (triangle.calculable && triangle.a.calculated && triangle.b.calculated && triangle.c.calculated) {
          //console.log(triangle)
         
          this.drawPoint2(triangle.a.x, triangle.a.y, triangle.a.name);
          this.drawLine(triangle.a.x, triangle.a.y, triangle.b.x, triangle.b.y,0);
          this.drawPoint2(triangle.b.x, triangle.b.y, triangle.b.name);
          this.drawLine(triangle.a.x, triangle.a.y, triangle.c.x, triangle.c.y,0);
          this.drawPoint2(triangle.c.x, triangle.c.y, triangle.c.name);
          this.drawLine(triangle.b.x, triangle.b.y, triangle.c.x, triangle.c.y,0);
          //this.drawLine(200,200,400,300,0);
        }
      }
    },

    drawInitPoints() {
      this.drawPoint2(this.points[0].x, this.points[0].y, this.points[0].name);
      this.drawPoint2(this.points[1].x, this.points[1].y, this.points[1].name);
    },

    async drawPoles() {
      for (let pole of this.Pols) {
        if (pole.activated) {
          if (pole.gon) {
            pole.angle_gon = pole.angle * 0.9;
            pole.reference_angle_gon = pole.reference_angle * 0.9;
          }

          let pole_point = this.points.find(obj => { return obj.name == pole.pole});
          let reference_point = this.points.find(obj => { return obj.name == pole.reference});
          //console.log(pole.reference_angle, pole.angle, pole.length, reference_point.x, reference_point.y, pole_point.x, pole_point.y)

          let angle_ac = pole.angle_gon - pole.reference_angle_gon;

          //console.log("pole check: ", pole.reference_angle, pole.angle, angle_ac)
        
          // Calculate the direction vector of AB
          const AB = { x: reference_point.x - pole_point.x, y: reference_point.y - pole_point.y };


          const AB_Length = Math.sqrt(AB.x ** 2 + AB.y ** 2);
          // Calculate the unit vector of AB
          const AB_UnitVector = { x: AB.x / AB_Length, y: AB.y / AB_Length };

          // Calculate the coordinates of point C
          const rotationAngleRadians = angle_ac * (Math.PI / 180);

          const C = { 
            x: pole_point.x + ((AB_UnitVector.x * Math.cos(rotationAngleRadians) - AB_UnitVector.y * Math.sin(rotationAngleRadians)) * pole.length * this.scaleFactor) ,
            y: pole_point.y + ((AB_UnitVector.x * Math.sin(rotationAngleRadians) + AB_UnitVector.y * Math.cos(rotationAngleRadians)) * pole.length * this.scaleFactor),
          };
          
          //console.log("pole: ", pole.name, C, angle_ac)

          this.points.push( { 
            name: pole.name,
            x: C.x,
            y: C.y,
            calculated: true
          });

          this.drawLine(pole_point.x, pole_point.y, C.x, C.y, 0, "yellow");
          this.drawPoint2(C.x, C.y, pole.name);

          //this.drawLine(pole_point.x, pole_point.y, pole_point.x + AB_UnitVector.x * 1000 , pole_point.y + AB_UnitVector.y * 1000, 0, "red");
        }
      }

    },

    async loadSvg(foreign_id) {

      this.selectedFile = null;
      this.lines = [];

      await this.getSvg({foreign_id: foreign_id});
      
      if (this.Svg.statusRequest == "success") {
        this.isLoaded = true;
        const c = document.getElementById("myCanvas");
        this.canvas = c.getContext('2d');
        this.scaleFactor = this.canvasY / this.Svg.Svg.info.scaleFactorX;
        let div = document.getElementById("svg");
        div.innerHTML = this.Svg.Svg.svg;

        //div.childNodes[2].setAttribute("width", 1000)
        let _viewBox = div.childNodes[2].getAttribute("viewBox");
      
        this.viewBox.height = Number(_viewBox.substring(_viewBox.lastIndexOf(" ") + 1,_viewBox.length));
        _viewBox = _viewBox.substring(0,_viewBox.lastIndexOf(" "));
        this.viewBox.width =  Number(_viewBox.substring(_viewBox.lastIndexOf(" ") + 1,_viewBox.length));

        div.childNodes[2].setAttribute("height", this.canvasY);
        this.canvasX = this.viewBox.width / this.viewBox.height * this.canvasY;
      } else {
        this.snackbar_text = this.Svg.statusRequestError.error;
        this.snackbar_color = "error";
        this.snackbar = true;
      }
    },

    setPoint() {
      if (!this.oldPoint) {
        this.oldPoint = {x: this.mouseX, y: this.mouseY};
        this.lines.push({id: this.pointsCounter, x: this.mouseX, y: this.mouseY, l: 0});
      } else {
        const dx = this.oldPoint.x - this.mouseX;
        const dy = this.oldPoint.y - this.mouseY;
        const len = Number((Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) / this.scaleFactor).toFixed(3));
        this.lines.push({id: this.pointsCounter, x: this.mouseX, y: this.mouseY, l: len});
        this.drawLine(this.oldPoint.x, this.oldPoint.y, this.mouseX, this.mouseY, len);
        this.oldPoint = {x: this.mouseX, y: this.mouseY};
      }
      this.drawPoint(this.mouseX, this.mouseY);
    },

    drawPoint(x, y) {
      this.pointsCounter++;
      let ctx = this.canvas;
      ctx.font = 'bold 22px Arial';
      ctx.fillStyle = 'red';
      ctx.fillText(this.pointsCounter, x, y);
    },

    drawPoint2(x, y, name) {
      this.pointsCounter++;
      let ctx = this.canvas;
      ctx.font = '22px Arial';
      ctx.fillStyle = 'red';
      ctx.fillText(name, x, y);
      
      ctx.beginPath();
      ctx.arc(x, y, 2, 0, 2 * Math.PI, false);
      ctx.fillStyle = 'yellow';
      ctx.fill();
      // ctx.stroke();

    },

    drawLine(x1, y1, x2, y2, len, color) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.setLineDash([2, 3]);/*dashes are 5px and spaces are 3px*/
      if (color) {
        ctx.strokeStyle = color;
      } else {
        ctx.strokeStyle = 'blue';
      }
      ctx.lineWidth = 1;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
      //console.log("Draw Line ", x1,y1,x2,y2)
      
      let xm = Math.abs(x1 - x2);
      let ym = Math.abs(y1 - y2);

      if (x1 <= x2) {
        xm = x1 + xm/2;
      } else {
        xm = x2 + xm/2;
      }
      if (y1 <= y2) {
        ym = y1 + ym/2;
      } else {
        ym = y2 + ym/2;
      }
      
      //ctx.font = 'bold 15px Arial';
      //ctx.fillStyle = 'blue';
      //ctx.fillText(String(len) + this.Svg.Svg.info.units, xm, ym);
    },

    readFileData(file) { 
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (res) => resolve(res.target.result);
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },

    async doConvertDxf(file) {
      
      const fileData = await this.readFileData(file);
      const base64 = Buffer.from(fileData, 'ascii').toString('base64');
      const data = {
        foreign_id: this.foreignId,
        filename: file.name.substring(0, file.name.length - 4),
        file: base64
      }

      await this.convertDxf(data);
      if (this.Svg.statusUpdate == "success") {    
        this.loadSvg(this.foreignId);
      } else {
        this.snackbar_text = this.Svg.statusUpdateError.error;
        this.snackbar_color = "error";
        this.snackbar = true;
      }
      
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async deleteItem(item) {
      const index = this.Lines.indexOf(item);
      await this.deleteLine(item._id);
      if (this.LineState.statusDelete == "success") {
        this.Lines.splice(index, 1);
      } else {
        this.snackbar_text = "Already deleted";
        this.snackbar = true;
      }
    },

    createItem () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.dialog = true
    },

    async editItem(item) {
      
      this.editedIndex = this.inputs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      //console.log("editItem ", this.editedItem, this.editedIndex);
      this.dialog = true;
    },

    async save() {
      if (!Number(this.editedItem.angle) && this.editedItem.angle.indexOf(",")) {
        this.editedItem.angle = this.editedItem.angle.replace(",",".");
      }
      
      if (this.editedIndex > -1) {
        //console.log(this.editedItem);
        await this.updateLine(this.editedItem);
        if (this.LineState.statusUpdate == "success") {
          Object.assign(this.inputs[this.editedIndex], this.editedItem);
          this.snackbar_text ="Update succesful";
          this.snackbar_color = "success";
          this.snackbar = true;
        } else {
          this.snackbar_text =
            "Filename existiert bereits oder Server nicht erreichbar";
          this.snackbar_color = "error";
          this.snackbar = true;
        }
      } else {
        await this.createLine(this.editedItem);
        if (this.LineState.statusCreate == "success") {
          this.editedItem._id = this.LineState.Line._id;
          this.editedItem.file_id = this.LineState.Line.file_id;
          this.editedItem.updatedAt = this.$moment(this.LineState.Line.updatedAt).format("DD-MM-YYYY HH:mm");
          this.Lines.push(this.editedItem);
          this.snackbar_text ="Save succesful";
          this.snackbar_color = "success";
          this.snackbar = true;
        } else {
          this.snackbar_text =
            "Filename existiert bereits oder Server nicht erreichbar";
            this.snackbar_color = "error";
          this.snackbar = true;
        }
      }
      //this.close();
      
    },

    closePole() {
      this.dialog_pole = false;
      this.$nextTick(() => {
        this.editedItemPole = Object.assign({}, this.defaultItemPole);
        this.editedIndexPole = -1;
      });
    },

    async savePole() {
      //console.log("savePole: ", this.editedItemPole)
      // if (!Number(this.editedItemPole.angle) && this.editedItemPole.angle.indexOf(",")) {
      //   this.editedItemPole.angle = this.editedItemPole.angle.replace(",",".");
      // }
      // if (!Number(this.editedItemPole.reference_angle) && this.editedItemPole.reference_angle.indexOf(",")) {
      //   this.editedItemPole.reference_angle = this.editedItemPole.reference_angle.replace(",",".");
      // }

      if (this.editedIndexPole > -1) {
        await this.updatePol(this.editedItemPole);
        if (this.PolState.statusUpdate == "success") {
          Object.assign(this.Pols[this.editedIndexPole], this.editedItemPole);
          this.snackbar_text ="Update succesful"
          this.snackbar_color = "success";
          this.snackbar = true;
        } else {
          this.snackbar_text =
            "Filename existiert bereits oder Server nicht erreichbar";
          this.snackbar_color = "error";
          this.snackbar = true;
        }
      } else {
        await this.createPol(this.editedItemPole);
        if (this.PolState.statusCreate == "success") {
          this.editedItemPole._id = this.PolState.Pol._id;
          this.editedItemPole.file_id = this.PolState.Pol.file_id;
          this.editedItemPole.updatedAt = this.$moment(this.PolState.Pol.updatedAt).format("DD-MM-YYYY HH:mm");
          this.Pols.push(this.editedItemPole);
          this.snackbar_text ="Save succesful";
          this.snackbar_color = "success";
          this.snackbar = true;
        } else {
          this.snackbar_text =
            "Filename existiert bereits oder Server nicht erreichbar";
          this.snackbar_color = "error";
          this.snackbar = true;
        }
      }
      
    },
    createItemPole () {
      this.editedItemPole = Object.assign({}, this.defaultItemPole)
      this.editedIndexPole = -1
      this.dialog_pole = true
    },

    async editItemPole(item) {
      //console.log("editItem Pole ", item);
      this.editedIndexPole = this.Pols.indexOf(item);
      //this.editedItemPole = Object.assign({}, item);
      this.editedItemPole = JSON.parse(JSON.stringify(item))
      this.dialog_pole = true;
    },

    async deleteItemPole(item) {
      const index = this.Pols.indexOf(item);
      await this.deletePol(item._id);
      if (this.PolState.statusDelete == "success") {
        this.Pols.splice(index, 1);
      } else {
        this.snackbar_text = "Already deleted";
        this.snackbar = true;
      }
    },

    calcSettings() {
      
      const factor = 0.2247617;
      const ab_gis = Number(this.points_settings.length / factor);
      const ccw_x = Number(Math.cos(this.points_settings.reference_angle));
      const ccw_y = Number(Math.sin(this.points_settings.reference_angle));
      //console.log(factor, ccw_x, ccw_y, this.points_settings.Ax, this.points_settings.Ay)
      this.points_settings.Ax = Number(this.points_settings.Ax);
      this.points_settings.Ay = Number(this.points_settings.Ay);
      this.points_settings.Bx = Number(Number(this.points_settings.Ax) + (ab_gis * ccw_x));
      this.points_settings.By = Number(Number(this.points_settings.Ay) + (ab_gis * ccw_y));
      this.points_settings.rotationAngleDegrees = (this.points_settings.reference_angle * 360) / (2 * Math.PI) ;

      this.setInitPoints();
    }
  },
  watch: {
    "points_settings.Ax" (setting) {
      this.calcSettings();
    },
    "points_settings.Ay" (setting) {
      this.calcSettings();
    },
    "points_settings.reference_angle" (setting) {
      this.calcSettings();
    },
    "points_settings.ABangle" (setting) {
      this.calcSettings();
    },
    "points_settings.length" (setting) {
      this.calcSettings();
    },

    selectedFile (file) {
      if (file) {
        if (file.name.substr(file.name.length - 3).toLowerCase() != "dxf") {
          // No DXF
          this.selectedFile = null;
          this.snackbar_text = "Not a DXF File";
          this.snackbar_color = "error";
          this.snackbar = true;
        } else {
          this.doConvertDxf(file);
        }
      }
    },
    foreignId (id) {
      // let div = document.getElementById("svg");
      // div.innerHTML = "";
      // this.canvas = null;
    }
  },
};
</script>

<style lang='scss'>
.box {
  border: solid 1px black;
  position: absolute;
  left: 0px;
  top: 200px;
}
.image_style {
  position: absolute;
  left: -250px;
  top: 130px;
  opacity: 0.6 !important;
}
.canvas_style {
  z-index: 10;
  position: absolute;
  left: 0px;
  top: 130px;
}
.dataPosition {
  position: absolute;
  top: 2050px;
  left: 0px;
}
</style>